import axios from "axios";

const movieApi = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

export default movieApi;
